import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";
import Card from "@material-ui/core/Card";

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f4f7f6;
  padding-bottom: 50px;
`;

export const ContainerBody = styled.div`
  width: 95%;
  margin: 0 auto;
  padding-top: 20px;

  @media ${dispositivo.tablet} {
    width: 90%;
  }
`;

export const WorkspaceHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);

  @media ${dispositivo.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ButtonAdd = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #67D2DC;
  color: #0C234C;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(103, 210, 220, 0.2);

  &:hover {
    background: #5dbdc7;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(103, 210, 220, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ButtonCompletar = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #0c8de3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #0a79c2;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(12, 141, 227, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 1.2rem;
  }
`;

export const ButtonFinalizar = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f44336;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(244, 67, 54, 0.2);

  &:hover {
    background: #d32f2f;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(244, 67, 54, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ButtonIniciar = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #67D2DC;
  color: #0C234C;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(103, 210, 220, 0.2);

  &:hover {
    background: #5dbdc7;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(103, 210, 220, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  background: #fdfdfd;
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid #eee;
`;

export const TimeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 0.7rem;
    color: #888;
    text-transform: uppercase;
    font-weight: bold;
  }

  input {
    border: none;
    background: transparent;
    font-family: inherit;
    font-size: 1rem;
    color: #0C234C;
    font-weight: 600;
    padding: 2px 0;
    border-bottom: 2px solid transparent;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-bottom-color: #67D2DC;
    }
  }
`;

export const WorkspaceTitle = styled.h1`
  font-size: 1.5rem;
  color: #0C234C;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 24px;
    background: #67D2DC;
    border-radius: 2px;
  }
`;

export const SectionAtencion = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TarjetaAtencion = styled(Card)`
  display: grid;
  grid-template-columns: 1fr;
  padding: 20px;
  border-radius: 15px !important;
  border-left: 6px solid ${props => props.terminado ? '#4caf50' : '#0c8de3'};
  box-shadow: 0 8px 16px rgba(0,0,0,0.08) !important;
  transition: all 0.2s;
  background: ${props => props.terminado ? '#f9fdfa' : 'white'} !important;
  opacity: ${props => props.terminado ? '0.9' : '1'};

  @media ${dispositivo.tablet} {
    grid-template-columns: 250px 1fr 140px;
    gap: 20px;
  }
`;

export const InfoTratamiento = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NombreTratamiento = styled.h4`
  font-size: 1.2rem;
  color: #0C234C;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const DientesEtiqueta = styled.div`
  font-size: 0.9rem;
  color: #666;
  background: #eef2f5;
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  font-weight: 500;
`;

export const NotaClinicaContainer = styled.div`
  width: 100%;
`;

export const NotaClinicaTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 15px;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  color: #333;
  resize: vertical;
  background: #f9f9f9;
  line-height: 1.5;

  &:focus {
    outline: none;
    border-color: #67D2DC;
    background: white;
    box-shadow: 0 0 0 3px rgba(103, 210, 220, 0.1);
  }

  &::placeholder {
    color: #aaa;
    font-style: italic;
  }
`;

export const AccionesTarjeta = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const EmptyState = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  background: white;
  border-radius: 20px;
  border: 2px dashed #d0d7de;
  color: #666;

  h2 {
    color: #0C234C;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
`;

export const SesionIndicator = styled.div`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 800;
  color: ${props => props.final ? '#e91e63' : '#4caf50'};
  display: flex;
  align-items: center;
  gap: 5px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }
`;
